module.exports = __webpack_public_path__ + "img/suport inactive.2d4825aa.svg";